module.exports = __webpack_public_path__ + "static/media/Chisom_Image_author.0304feb4.png";